import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ModalBase } from '../modal-base.component';
import { ModalData, ValidationError, ValidationModalData } from '../../models';
import { MessageModalComponent } from '../message-modal/message-modal.component';

@Component({
  selector: 'send-validation-modal',
  templateUrl: './send-validation-modal.component.html',
  styleUrls: [
    './send-validation-modal.component.scss',
    '../../../../../../assets/styles/components/modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SendValidationModalComponent extends ModalBase {
  validationErrors: ValidationError[];

  constructor(protected dialogRef: MatDialogRef<MessageModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: string | { message: string, title: string } | ValidationModalData) {
    super(data);
  }

  ok(): void {
    this.dialogRef.close();
  }

  public isInfoModalData(): boolean {
    return this.data instanceof ModalData;
  }

  protected setMessages(data: string | { message: string, title: string } | ValidationModalData): void {
    if (data instanceof ModalData) {
      this.title = data.title;
      this.message = data.message;
      this.translateParams = data.translateParams;
      this.validationErrors = data.validationErrors;
      this.link = data.link;
    } else if (typeof data === 'string') {
      this.message = data;
    } else {
      this.message = data.message ? data.message : '';
      this.title = data.title ? data.title : '';
    }
  }

}

